<mat-form-field  class="full-width">
    <!-- <mat-label>Enter a date range</mat-label> -->
    <mat-date-range-input [rangePicker]="picker">
      <input matStartDate placeholder="Ngày bắt đầu">
      <input matEndDate placeholder="Ngày kết thúc">
    </mat-date-range-input>
    <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>